import Layout from '../views/layout/App.vue'
import Empty from '../views/layout/Empty.vue'
export default {
    path: '/coursePackage',
    name: 'CoursePackage',
    meta: {
        title: '课程包管理',
        keepAlive: false
    },
    component: Layout,
    redirect: '/coursePackage/coursePackageIndex',
    children: [{
            path: 'coursePackageIndex',
            name: 'CoursePackageIndex',
            meta: {
                title: '课程包列表',
                keepAlive: true
            },
            component: resolve => require(['@/views/coursePackage/coursePackage/Index.vue'], resolve),
        },

        {
            path: 'coursePackageIndex',
            name: 'coursePackageIndex',
            component: Empty,
            meta: {
                title: '课程包列表',
                keepAlive: true
            },
            children: [{
                    path: 'CourPackgeAdd',
                    name: 'CourPackgeAdd',
                    meta: {
                        title: '编辑课程包',
                        keepAlive: false
                    },
                    component: resolve => require(['@/views/coursePackage/coursePackage/CourPackgeAdd.vue'], resolve),
                },

                {
                    path: 'courPackgeAdd',
                    name: 'courPackgeAdd',
                    component: Empty,
                    meta: {
                        title: '编辑课程包',
                        keepAlive: false
                    },
                    children: [{
                            path: '/coursePackage/coursePackageIndex/CourPackgeAdd/CourAtomCheck',
                            name: 'CourAtomCheck',
                            meta: {
                                title: '选择原子课',
                                keepAlive: false
                            },
                            component: resolve => require(['@/views/coursePackage/coursePackage/CourAtomCheck.vue'], resolve),
                        },
                        {
                            path: '/coursePackage/coursePackageIndex/CourPackgeAdd/testQuestions',
                            name: 'TestQuestionsCour',
                            meta: {
                                title: '试题列表',
                                keepAlive: false
                            },
                            component: resolve => require(['@/views/examinationPaper/testQuestions/Index.vue'], resolve),
                        },
                        {
                            path: '/coursePackage/coursePackageIndex/CourPackgeAdd/AtomicClassDetailCourAdd',
                            name: 'AtomicClassDetailCourAdd',
                            meta: {
                                title: '预览原子课',
                                keepAlive: false
                            },
                            component: resolve => require(['@/views/atomicClasses/atomicClasses/AtomicClassDetail.vue'], resolve)

                        },
                        {
                            path: '/coursePackage/coursePackageIndex/CourPackgeAdd/CourPackgeDetail',
                            name: 'CourPackgeDetailckea',
                            meta: {
                                title: '预览课程包',
                                keepAlive: false
                            },
                            component: resolve => require(['@/views/coursePackage/coursePackage/CourPackgeDetail.vue'], resolve)

                        },
                        {
                            path: '/coursePackage/coursePackageIndex/CourPackgeAdd/CourAtomCheck',
                            name: 'CourAtomCheckDetail',
                            component: Empty,
                            meta: {
                                title: '选择原子课',
                                keepAlive: false
                            },
                            children: [{
                                path: '/coursePackage/coursePackageIndex/CourPackgeAdd/CourAtomCheck/AtomicClassDetailCour',
                                name: 'AtomicClassDetailCour',
                                meta: {
                                    title: '预览原子课',
                                    keepAlive: false
                                },
                                component: resolve => require(['@/views/atomicClasses/atomicClasses/AtomicClassDetail.vue'], resolve)

                            }]
                        }, {
                            path: '/coursePackage/coursePackageIndex/CourPackgeAdd/CourPageCheck',
                            name: 'CourPageCheck',
                            meta: {
                                title: '选择课程包',
                                keepAlive: false
                            },
                            component: resolve => require(['@/views/coursePackage/coursePackage/CourPageCheck.vue'], resolve),
                        },
                        {
                            path: '/coursePackage/coursePackageIndex/CourPackgeAdd/CourPageCheck',
                            name: 'CourPageChecks',
                            meta: {
                                title: '选择课程包',
                                keepAlive: false
                            },
                            component: Empty,
                            children: [{
                                path: '/coursePackage/coursePackageIndex/CourPackgeAdd/CourPageCheck/CourPackgeDetail',
                                name: 'CourPackgeDetailcke',
                                meta: {
                                    title: '预览课程包',
                                    keepAlive: false
                                },
                                component: resolve => require(['@/views/coursePackage/coursePackage/CourPackgeDetail.vue'], resolve)

                            }]
                        }
                    ]
                }
            ]
        }
    ]
}